/**
 * 状态 Tag 的图标位（迭代状态 / 批次状态共用）。
 *
 * 🔴 「发布中」（PUBLISHING，迭代与批次同值）原来是后端下发的静态图标 ◐，
 *    用户看不出它到底还在不在跑 —— 现换成 antd 的 <LoadingOutlined spin> 转圈动效；
 *    其余状态原样展示后端 statusIcon（后端改图标前端不动）。
 *
 * 只管「转不转 + 显示哪个图标」，颜色仍由外层 Tag 的 tag-* 类决定，不在这里自造颜色。
 */
/* eslint react/prop-types: "off" -- 本模块用 JSDoc 声明 props，不额外引 prop-types */
import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

export default function StatusIcon({ spinning, icon }) {
  if (spinning) return <LoadingOutlined spin />;
  return icon || null;
}
